import { ICmsDraft } from '@icms/core/resource/draft/icms-draft';
import { ICmsModel } from '../../../../core/resource/model/icms-model';
import { NICmsCampaigns } from '../../icms-campaigns-interfaces';

export class ICmsCampaign extends ICmsModel<NICmsCampaigns.ICampaignData, number> {
    /**
     * Object type id
     */
    static override readonly type = 'campaign';

    /**
     * Max verbosity
     */
    override maxVerbosity = 1;

    /**
     * If works with scope data
     */
    override hasScopeData = false;

    async loadDrafts(reload = false): Promise<any> {
        return this.resources.draft.find(
            { filter: { campaign: this.id }, verbosity: 1 },
            {
                noCache: reload
            }
        );
    }

    get drafts(): ICmsDraft[] {
        return this.resources.draft.getAllExisting().filter(i => i.data?.campaign === this.id);
    }

    get isPublished(): boolean {
        return this.data?.status === 'published';
    }
}
